<template>
  <div>
    <modal
      v-if="visible"
      ref="modal"
      size="small"
      :hideCloseButton="closeButton"
      :showControls="false"
      @close-modal="closeModal"
    >
      <div slot="header">
        Filtros
      </div>
      <div class="container" slot="content">
          <div class="form-box -full -left">

          <div class="field-box">
            <div class="label-filter">
              <label class="font-medium text-sm">Status do processo</label>
               <button class="clean-button" @click="limparFiltro('status')">Limpar</button>
            </div>

            <select
              name="selectStatus"
              v-model="filtros_.status"
              class="field px-3 rounded-md text-sm"
            >
              <option :value="null">
                Todos
              </option>

              <option :value="true">
                Processo ativo
              </option>

              <option :value="false">
                Processo inativo
              </option>
            </select>
          </div>

          <div class="field-box">
            <div class="label-filter">
              <label class="font-medium text-sm">Incluir homônimos <small>(apenas CPF)</small></label>
              <button class="clean-button" :disabled="!termoCpf" @click="limparFiltro('incluir_homonimos')">Limpar</button>
            </div>

            <div class="field-content-radio">
              <div class="filtro-radio">
                <input type="radio" id="incluir_nao" name="incluir_homonimo"
                       :value="false" v-model="filtros_.incluir_homonimos" checked>
                 <label for="incluir_nao"  class="font-medium text-sm">Não</label>
              </div>

              <div class="filtro-radio">
                <input type="radio" :disabled="!termoCpf" id="incluir_sim" name="incluir_homonimo"
                       :value="true" v-model="filtros_.incluir_homonimos">
                 <label for="incluir_sim"  class="font-medium text-sm">Sim</label>
              </div>
            </div>
          </div>

          <div class="field-box">
            <div class="label-filter">
              <label class="font-medium text-sm">Tribunais</label>
              <button class="clean-button" @click="limparFiltro('tribunais')">Limpar</button>
            </div>
            <AppDropdown
              ref="trDropdown"
              :target="{ attrs: { type: 'button' } }"
              :theme="{ target: ['border', 'w-full', '!justify-start', 'font-medium', ' text-sm'] }"
              :v-popover="{ placement: 'top'}"
              @show="changeStyle('trDropdown')"
            >
              <template #target>
                {{ tribunaisLabel }}
              </template>
              <template #popover>
                <div slot="popover">
                  <div class="border-b flex flex-nowrap">
                    <div class="py-4 pl-4 bg-white">
                      <AppSvgSymbol name="@escavador/search" size="18" />
                    </div>
                    <input
                      class="p-4 border-none outline-0 w-full text-sm"
                      type="text"
                      v-model="searchTribunal"
                      placeholder="Pesquisar"
                    />
                  </div>

                  <div class="filtro-content">
                    <ul class="w-full border-gray-300 z-10 rounded-lg bg-white overflow-y-auto max-h-[400px] max-w-[300px]">
                      <li v-for="item in tribunaisFiltrados"
                          class="flex w-full filtro-checkbox"
                      >
                        <input type="checkbox"
                               :id="item.id"
                               :value="item.sigla"
                               v-model="filtros_.tribunais"
                        />
                        <label :for="item.id">{{ item.nome }}
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </template>
            </AppDropdown>
          </div>

          <div>
            <div>
              <div class="label-filter">
                <p class="font-medium text-sm m-0">Início do processo</p>
                <button class="clean-button" @click="limparFiltro('date')">Limpar</button>
              </div>
              <small
                v-if="dataInvalida"
                class="form-error"
              >
                A data máxima é anterior à data mínima.
              </small>
            </div>

            <div class="field-box">
              <label class="font-medium text-sm">Data mínima</label>
              <AppDropdown
                ref="dateDropdownPlayStart"
                :target="{ attrs: { type: 'button' } }"
                :theme="{ target: ['border', 'w-full', '!justify-start', 'font-medium', ' text-sm'] }"
                @show="changeStyle('dateDropdownPlayStart')"
              >
                <template #target>
                  {{ formatDates(filtros_.dateOne) || "Selecionar data" }}
                </template>
                <template #popover>
                  <AppCalendar
                    style="width: 100% !important;"
                    :use-controls="true"
                    :show-select-year="true"
                    :finalDate="endDate"
                    :positive-control="{text: 'Selecionar'}"
                    mode="single"
                    @select-date="addStartDate"
                    @date-confirmation="closeDropdown('dateDropdownPlayStart')"
                  />
                </template>
              </AppDropdown>
            </div>

            <div class="field-box">
              <label class="font-medium text-sm">Data máxima</label>
              <AppDropdown
                ref="dateDropdownPlayEnd"
                :target="{ attrs: { type: 'button' } }"
                :theme="{ target: ['border', 'w-full', '!justify-start', 'font-medium', ' text-sm'] }"
                @show="changeStyle('dateDropdownPlayEnd')"
              >
                <template #target>
                  {{ formatDates(filtros_.dateTwo) || "Selecionar data" }}
                </template>
                <template #popover>
                  <AppCalendar
                    style="width: 100% !important;"
                    :use-controls="true"
                    :show-select-year="true"
                    :finalDate="endDate"
                    :positive-control="{text: 'Selecionar'}"
                    mode="single"
                    @select-date="addEndDate"
                    @date-confirmation="closeDropdown('dateDropdownPlayEnd')"
                  />
                </template>
              </AppDropdown>
            </div>

          </div>

          <div class="div-buttons">
              <button class="btn -left -color -clear -medium"
                      @click="limparTodosFiltros">
                <b>Limpar filtros</b>
              </button>

              <button class="btn -right"
                      :disabled="!mudouFiltro || dataInvalida"
                      @click="salvarFiltro">
                <b>Salvar</b>
              </button>
          </div>
        </div>
    </div>
  </modal>
  </div>
</template>

<script>
import AppCalendar from "../../../_painel_admin/components/global/AppCalendar/index.vue";
import format from "date-fns/format";
import parseISO from "date-fns/esm/fp/parseISO/index.js";
import pt from "date-fns/locale/pt";
import {isAfter} from "date-fns";
import AppSvgSymbol from "@escavador/global-components/AppSvgSymbol";
import latenize from "../../../../user/js/utils/latenize";


export default {
  name: "envolvido-processos-form-modal",
  components: {
    AppSvgSymbol,
    AppCalendar,
  },
  props: {
    visible: {
      required: true,
      type: Boolean
    },
    filtros: {
      required: true,
      type: Object
    },
    termoCpf: {
      required: true,
      type: Boolean
    },
    tribunais: {
      required: true,
      type: Array
    }
  },
  watch: {
    visible (next) {
      if (next) this.estadoInicial();
    }
  },
  data() {
    return {
      closeButton: false,
      submited:false,
      listaTribunais: [],
      dateFormat: "dd MMM yyyy",
      checked_: true,
      searchTribunal: "",
      filtros_: {
        tribunais: [],
        status: null,
        incluir_homonimos: false,
        dateOne: "",
        dateTwo: "",
      }
    };
  },
  computed: {
    mudouFiltro() {
      const props = Object.keys(this.filtros_);

      for (const prop of props) {
        if (this.filtros_[prop] !== this.filtros[prop]) {
          return true;
        }
      }

      return false;
    },
    endDate() {
      return new Date();
    },
    tribunaisFiltrados() {
      return this.tribunais.filter((option) =>
        this.optionSearch(option, this.searchTribunal)
      )
    },
    tribunaisLabel() {
      if (this.filtros_.tribunais.length) {
        return this.filtros_.tribunais.slice(0, 5).join(', ') + (this.filtros_.tribunais.length > 5 ? '...' : '')
      } else {
        return "Todos"
      }
    },
    dataInvalida(){
      if (this.filtros_.dateOne.length || this.filtros_.dateTwo.length) {
        return isAfter(new Date(this.filtros_.dateOne), new Date(this.filtros_.dateTwo))
      }
      return false;
    },
  },
  methods: {
    optionSearch(option, term) {
      return term
        ? latenize(option?.nome + " " + option?.sigla || "").includes(latenize(term))
        : option;
    },
    estadoInicial() {
      Object.assign(this.filtros_, this.filtros);
    },
    changeStyle(nomeRef){
      let popover = this.$refs[nomeRef].$children[0].$refs['popover'];
      popover.style.zIndex = "9999";
    },
    limparTodosFiltros() {
      this.filtros_.tribunais = [];
      this.filtros_.status = null;
      this.filtros_.incluir_homonimos = false;
      this.filtros_.dateOne = "";
      this.filtros_.dateTwo = "";
    },
    limparFiltro(prop){
      if (prop === 'date') {
        this.filtros_.dateOne = "";
        this.filtros_.dateTwo = "";
      }

      if (prop === 'tribunais') {
        this.filtros_.tribunais = [];
      }

      if (prop === 'incluir_homonimos') {
        this.filtros_.incluir_homonimos = false;
      }

      if (prop === 'status') {
        this.filtros_.status = null;
      }
    },
    salvarFiltro() {
      this.$emit("addFiltro", this.filtros_);
      this.$refs.modal?.closeModal();
    },
    closeModal() {
      this.$emit("closeModal");
    },
    addStartDate($event) {
      this.filtros_.dateOne = ($event && $event.sql) || "";
    },
    addEndDate($event) {
      this.filtros_.dateTwo = ($event && $event.sql) || "";
    },
    closeDropdown(nomeRef) {
      this.$refs[nomeRef].hide();
    },
    formatDates(date) {
      if (date) {
        return  format(parseISO(date), this.dateFormat, {
          locale: pt,
        });
      }
    },
  }
};
</script>
<style lang="stylus" scoped>
.container
  width 300px

.form-box.-full
  max-width 296px

  @media (max-width: 768px)
    max-width none

.form-box
  display flex
  flex-direction column
  gap 20px

.div-buttons
  padding-top 10px

.label-filter
  align-items baseline
  display flex
  justify-content space-between
  width 100%

.clean-button
  color #AFAEBA
  cursor pointer
  font-size 12px
  font-weight 600

.form-error
  color #DC6C51

input[type="checkbox"], input[type="radio"]
  max-width 20px
  max-height 20px

.filtro-checkbox
  display flex
  align-items: center;
  padding: 4px 14px;
  gap: 12px;
  font-size: 14px;

.filtro-checkbox:hover
  background-color rgba(229, 231, 235, 1);

ul
  margin 0

.filtro-content
  height 300px

.filtro-radio
  display flex
  align-items center
  gap 6px

.field-content-radio
  display flex
  gap 20px
</style>
